// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
export type GetSpaceCapacityEventFragment = { __typename?: 'Event', layoutID: string };

export type GetSpaceCapacityProposalFragment = { __typename?: 'Proposal', space: { __typename?: 'SelfServeSpace', spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null } };

export const GetSpaceCapacityEventFragmentDoc = gql`
    fragment GetSpaceCapacityEvent on Event {
  layoutID
}
    `;
export const GetSpaceCapacityProposalFragmentDoc = gql`
    fragment GetSpaceCapacityProposal on Proposal {
  space {
    spatialConfigurations {
      name
      capacity
    }
  }
}
    `;